import { render, staticRenderFns } from "./FrzWeighedByBatch.vue?vue&type=template&id=0f0ca4c5"
import script from "./FrzWeighedByBatch.vue?vue&type=script&lang=js"
export * from "./FrzWeighedByBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports